export default "__VITE_ASSET__BRYkzDtt__"